// ============================================================================
// chatAttachmentLimits.ts — лимиты и проверка файлов для композера вложений
// чата (SSoT на клиенте; proto/сервер не меняются).
// ============================================================================

import { formatBytes } from '@/components/chat/chatInfoData';

/** Лимиты вложений чата. */
export const MAX_CHAT_ATTACHMENTS = 10;
export const MAX_CHAT_ATTACHMENT_BYTES = 100 * 1024 * 1024;
export const MAX_CHAT_ATTACHMENTS_TOTAL_BYTES = 250 * 1024 * 1024;

export interface ChatAttachmentValidation {
  accepted: File[];
  warnings: string[];
}

/**
 * Проверка выбранных файлов: количество, размер каждого и суммарный размер.
 * Возвращает допустимые файлы и понятные предупреждения по отклонённым.
 */
export function validateChatAttachmentFiles(files: File[], alreadyAttached = 0): ChatAttachmentValidation {
  const accepted: File[] = [];
  const warnings: string[] = [];
  let count = Math.max(0, alreadyAttached);
  let total = 0;
  let countWarned = false;
  for (const file of files) {
    if (count >= MAX_CHAT_ATTACHMENTS) {
      if (!countWarned) {
        warnings.push(`Не больше ${MAX_CHAT_ATTACHMENTS} файлов в одном сообщении`);
        countWarned = true;
      }
      continue;
    }
    if (file.size > MAX_CHAT_ATTACHMENT_BYTES) {
      warnings.push(`«${file.name}» больше ${formatBytes(MAX_CHAT_ATTACHMENT_BYTES)}`);
      continue;
    }
    if (total + file.size > MAX_CHAT_ATTACHMENTS_TOTAL_BYTES) {
      warnings.push(`Суммарный размер вложений больше ${formatBytes(MAX_CHAT_ATTACHMENTS_TOTAL_BYTES)}`);
      break;
    }
    accepted.push(file);
    total += file.size;
    count++;
  }
  return { accepted, warnings };
}
